import { render, staticRenderFns } from "./a-global-notifications.vue?vue&type=template&id=149e3ea1"
import script from "./a-global-notifications.vue?vue&type=script&lang=js"
export * from "./a-global-notifications.vue?vue&type=script&lang=js"
import style0 from "./a-global-notifications.vue?vue&type=style&index=0&id=149e3ea1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports